module.exports = __webpack_public_path__ + "static/monkey_768-0a43a2e484d60cd43ce03e5b5e1883b0.mp4";